import { render, staticRenderFns } from "./ServiceRequestSimpleAgreement.vue?vue&type=template&id=2c2cccfd&scoped=true"
import script from "./ServiceRequestSimpleAgreement.vue?vue&type=script&lang=js"
export * from "./ServiceRequestSimpleAgreement.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestSimpleAgreement.vue?vue&type=style&index=0&id=2c2cccfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2cccfd",
  null
  
)

export default component.exports